import React from 'react';

interface IHintIconCompleteProps {
	size?: string;
	fill?: string;
	className?: string;
}

export const HintIconComplete = ({
	size = '24',
	className = '',
	fill = '#2E7D32',
}: IHintIconCompleteProps) => (
	<svg
		role="img"
		className={className}
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-labelledby="hintIconComplete">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M20.56 9.21497L23 11.995L20.56 14.775L20.9 18.455L17.29 19.275L15.4 22.455L12 20.995L8.6 22.465L6.71 19.285L3.1 18.465L3.44 14.775L1 11.995L3.44 9.20497L3.1 5.52497L6.71 4.71497L8.6 1.53497L12 2.99497L15.4 1.53497L17.29 4.71497L20.9 5.53497L20.56 9.21497ZM6 12.995L10 16.995L18 8.99497L16.59 7.57497L10 14.165L7.41 11.585L6 12.995Z"
			fill={fill}
		/>
	</svg>
);
